module["exports"] = [
  "Jr.",
  "Sr.",
  "I",
  "II",
  "III",
  "IV",
  "V",
  "MD",
  "DDS",
  "PhD",
  "DVM"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en/name/suffix.js
// module id = 1113
// module chunks = 1